import React from "react";
import { useSelector } from "react-redux";
import { Card, CardBody, Spinner, Badge } from "reactstrap";
import { toArray } from "../../helpers/common";

const PlanDetailBox = ({ planId }) => {
  const orders = useSelector((state) => state.orders);
  const plans = orders.plans || [];
  const plan_loading = orders.plan_loading;

  // Access plans.data and add a fallback empty array [] to prevent the crash
  const selectedPlan = (Array.isArray(plans?.data) ? plans.data : []).find(
    (item) => item?.id === parseInt(planId)
  );

  if (!plan_loading && !selectedPlan) {
    return <Card className='bg-light p-5 text-center'>Sorry, details are not found.</Card>;
  }

  return (
    <Card className='border-0 shadow-sm overflow-hidden' style={{ borderRadius: '15px' }}>
      {/* Accent top border to match your brand color */}
      <div style={{ height: '5px', backgroundColor: '#387ed8' }}></div>

      {plan_loading ? (
        <div className='text-center p-5'>
          <Spinner animation="border" variant="primary" />
        </div>
      ) : (
        <CardBody className='p-4 px-lg-5'>
          {/* Plan Name */}
          <div className='text-center mb-3'>
            <Badge
              bg="none"
              className="text-uppercase mb-2 px-3 py-2"

            >
              {selectedPlan?.name || "Standard Plan"}
            </Badge>
          </div>

          {/* Pricing Section */}
          <div className='text-center mb-4'>
            <h2 className='fw-bold mb-0' style={{ color: '#2d3748' }}>
              ₹{parseInt(selectedPlan?.planAmount || 0)}
            </h2>
            <p className="text-muted fs-14">Available for immediate use</p>
          </div>

          <hr className="my-4 opacity-25" />

          {/* Plan Features Title */}
          <div className='mb-3'>
            <h6 className='fw-bold fs-15 text-dark'>
              <i className="uil uil-star me-2 text-warning"></i>
              Plan Features: <span className="fw-normal text-muted">{selectedPlan?.features}</span>
            </h6>
          </div>

          {/* Description List */}
          <ul className='list-unstyled mb-4'>
            {/* Note: changed "/n" to "\n" which is the standard newline character */}
            {(selectedPlan?.description?.split('\n') || [])?.map((desc, index) => (
              desc.trim() && (
                <li key={index} className="d-flex align-items-start mb-3">
                  <div
                    className="rounded-circle d-flex align-items-center justify-content-center me-3 mt-1"
                    style={{
                      minWidth: '22px',
                      height: '22px',
                      backgroundColor: 'rgba(56, 126, 216, 0.12)',
                      color: '#387ed8'
                    }}
                  >
                    <i className="mdi mdi-check-bold fs-12"></i>
                  </div>
                  <span className="text-muted fs-15 lh-sm">{desc}</span>
                </li>
              )
            ))}
          </ul>


        </CardBody>
      )}
    </Card>
  );
};

export default PlanDetailBox;
